import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import Button from "@streeteasy/design-system/deprecated/Button";
import { gql } from "apollo-boost";
import { string } from "prop-types";

import claimDealGA from "../analytics/index";
import ClaimDealModal from "../ClaimDealModal";
import ClaimedDealHDPMessage from "../ClaimedDealHDPMessage";
import SuccessModal from "../SuccessModal";
import * as S from "./styled";

export const CLAIM_CLOSING = gql`
  mutation ClaimClosing($closing_id: ID!) {
    claim_closing(input: { closing_id: $closing_id }) {
      closing {
        id
      }
    }
  }
`;

const ClaimDealBox = props => {
  const [isClaimedDeal, setClaimedDeal] = useState(false);
  const [isClaimModalOpen, setClaimModalOpen] = useState(false);
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);
  const [claimClosing] = useMutation(CLAIM_CLOSING);

  const handleOnClaim = () => {
    claimClosing({ variables: { closing_id: props.closingId } }).then(
      () => {
        setClaimModalOpen(false);
        setSuccessModalOpen(true);
        setClaimedDeal(true);
        claimDealGA("claim_buyside_deals", "submit");
      },
      error => {
        console.log("ERROR", error);
      }
    );
  };

  return (
    <>
      {!isClaimedDeal && (
        <S.Container>
          <S.TextBox>
            <S.UITitle type="secondary">
              Were you the buyer&apos;s agent?
            </S.UITitle>
            <S.UIText type="sm">
              Get credit for it by claiming this deal
            </S.UIText>
          </S.TextBox>
          <S.ActionBox>
            <Button
              onClick={() => {
                setClaimModalOpen(true);
                claimDealGA("claim_buyside_deals", "open");
              }}
              theme="white"
            >
              Claim
            </Button>
          </S.ActionBox>
        </S.Container>
      )}
      {isClaimedDeal && <ClaimedDealHDPMessage />}
      <ClaimDealModal
        isOpen={isClaimModalOpen}
        onClickClaim={() => {
          handleOnClaim();
        }}
        onRequestClose={() => {
          setClaimModalOpen(false);
        }}
        titleAddress={props.listingTitle}
      />
      <SuccessModal
        address={props.listingTitle}
        isOpen={isSuccessModalOpen}
        onRequestClose={() => {
          setSuccessModalOpen(false);
        }}
      />
    </>
  );
};
ClaimDealBox.propTypes = {
  closingId: string.isRequired,
  listingTitle: string.isRequired
};
export default ClaimDealBox;
